// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-69705f32]:after{content:normal}.breadcrumb[data-v-69705f32]{background:#fff;font-size:13px;margin:0;min-height:20px;padding:0}.breadcrumb a[data-v-69705f32]{cursor:pointer}.breadcrumb .breadcrumb-item[data-v-69705f32]{text-transform:capitalize}.breadcrumb .fa[data-v-69705f32]{position:relative}@media(max-width:767px){.breadcrumb[data-v-69705f32]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
